// Libraries
import { Stack } from "@mui/material";

// Components
import InfoSubTitle from "@/Settings/components/SystemSettings/common/InfoSubTitle";
import SmartSelector from "@/Layouts/components/InputComponents/SmartSelector";

// Types
import { IKmsStore } from "@/Settings/types/administrationTools/model";
import { TSelectValue } from "@/Layouts/components/InputComponents/SmartSelector/interfaces";

// Helpers
import { isThereAnyNewChangeInStoreDropdown } from "@/Settings/helpers/AdministrationTools/DealerAdministrationTools/KeyManagementSystem";

type TStoreSelectorProps = {
	kmsStores: IKmsStore[];
	selectedKmsStores: IKmsStore[];
	isLoading: boolean;
	onChange: (values: IKmsStore[]) => void;
};

export default function StoreSelector(props: Readonly<TStoreSelectorProps>) {
	const { kmsStores, selectedKmsStores, isLoading, onChange } = props;

	function handleOnChangeAction(values: TSelectValue) {
		const updatedValues = (values as (IKmsStore & { disabled?: boolean })[]).map(
			({ disabled, ...rest }: IKmsStore & { disabled?: boolean }) => ({ ...rest })
		);

		isThereAnyNewChangeInStoreDropdown(selectedKmsStores, updatedValues as IKmsStore[]) && onChange(updatedValues as IKmsStore[]);
	}

	return (
		<Stack>
			<InfoSubTitle title={"Stores"} className={"!mb-[12px]"} />
			<SmartSelector
				selectBy={"id"}
				sortBy={"name"}
				showBy={"name"}
				options={kmsStores}
				selected={selectedKmsStores}
				loading={isLoading}
				inputProps={{
					placeholder: "Stores",
					classes: "!w-[280px] [&_.MuiInputBase-root>.MuiButtonBase-root>span.MuiChip-label]:!font-sans",
				}}
				listBoxProps={{
					sx: { maxHeight: "220px" },
				}}
				onChangeAction={handleOnChangeAction}
				multiple
			/>
		</Stack>
	);
}
